module.exports = __webpack_public_path__ + "static/media/credit-card-simulator.f925aa4b.png";